import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import customFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import "dayjs/locale/pt-br";
import "dayjs/locale/en";
dayjs.extend(utc);
dayjs.extend(customFormat);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
export const dayjsExtension = dayjs;
